import { useWallet } from '@/lib/walletHooks';
import { useMembers } from '@/features/echipa/api/teamHooks';
import { canSeeBilling } from '@/lib/permissions';
import { useMe } from '@/lib/useMe';

/** Renders across the top of the content when the org's balance is low
 *  (< 10% of the monthly reference — the server's `lowBalance` flag).
 *
 *  It used to say „Contactați administratorul" without naming anyone — a dead end
 *  at a high-stakes moment for the operator least likely to know who that is. The
 *  roster is already readable by any member, so name the owner/admin and make the
 *  address actionable. The query only runs while the banner is actually showing.
 *
 *  Billing-privacy: this is a money alert, so non-billing members (`!canSeeBilling`)
 *  never see it — `useWallet` is already disabled for them, but the explicit check
 *  here makes the gate unambiguous rather than relying on that side effect. */
export function LowBalanceBanner() {
  const { data: me } = useMe();
  const billing = canSeeBilling(me);
  const { data: w } = useWallet();
  const lowBalance = billing && Boolean(w?.lowBalance);
  const { data: members } = useMembers(lowBalance);

  if (!billing || !lowBalance) return null;

  const admin =
    members?.find((m) => m.role === 'owner') ?? members?.find((m) => m.role === 'admin');

  return (
    <div className="border-b border-warn bg-warn-wash px-4 py-2 text-[13.5px] text-ink md:px-12">
      Sold redus.{' '}
      {admin ? (
        <>
          Contactați{' '}
          <a
            href={`mailto:${admin.email}`}
            className="font-medium underline underline-offset-2"
          >
            {admin.name || admin.email}
          </a>{' '}
          pentru a alimenta portofelul.
        </>
      ) : (
        'Contactați administratorul organizației pentru a alimenta portofelul.'
      )}
    </div>
  );
}
